import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useAuth } from '@/hooks/useAuth';
import { Card } from '@/components/common/Card';
import { Button } from '@/components/common/Button';

export default function SettingsPage() {
  const { user } = useAuthStore();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-md-cream py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-md-graphite">Settings</h1>
          <div className="flex items-center gap-3">
            <Link
              to="/downloads"
              className="text-sm font-medium text-md-sky-strong hover:text-md-graphite transition-colors"
            >
              Desktop App
            </Link>
            <Button variant="secondary" size="sm" onClick={logout}>
              Logout
            </Button>
          </div>
        </div>

        <Card className="mb-6">
          <h2 className="text-xl font-bold text-md-graphite mb-4">User Profile</h2>
          <div className="space-y-2">
            <p><strong>Username:</strong> {user?.username}</p>
            <p><strong>Email:</strong> {user?.email}</p>
            <p><strong>Name:</strong> {user?.name}</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
